export const convertIntoMath = (str) => {
    if (!str) {
        return str;
    }
    return str
        ?.replace('<span class="math-tex">\\(', '$')
        ?.replace('\\)</span>', '$');
};

export const noColumnInQuestion = ['8', '9', '10', '11', '12'];
export const XPattern = /\(x\d+\)\./g;

// Helper: Clean up whitespace and invalid <br> tags inside table structures
export const cleanTableBrTags = (text) => {
    if (!text) return text;
    let str = String(text);
    // Remove <br> tags adjacent to table elements
    str = str.replace(/(<(?:\/?)(?:table|thead|tbody|tfoot|tr|th|td)[^>]*>)\s*<br\s*\/?>/gi, '$1');
    str = str.replace(/<br\s*\/?>\s*(<(?:\/?)(?:table|thead|tbody|tfoot|tr|th|td)[^>]*>)/gi, '$1');
    // Remove newlines/tabs between table elements (prevents them being converted to <br> later)
    str = str.replace(/(<(?:\/?)(?:table|thead|tbody|tfoot|tr|th|td)[^>]*>)[\n\r\t]+/gi, '$1');
    str = str.replace(/[\n\r\t]+(<(?:\/?)(?:table|thead|tbody|tfoot|tr|th|td)[^>]*>)/gi, '$1');
    // Remove trailing whitespace, <br>, and <p> tags after </table>
    str = str.replace(/(<\/table>)\s*(<br\s*\/?>|\s|<\/?p>)*/gi, '$1');
    return str;
};

// Helper: Add line breaks before options for display
const formatOptionBreaks = (text) => {
    if (!text) return text;
    return text;
};

// Shared helper for splitting "Rectify the errors" and "Fill in the blanks" questions
export const splitRectifyQuestion = (item, startCount, isFromEdit = false) => {
    const fullText = (item?.finalquestion || item?.question || "");
    const paragraphsArr = fullText.split(XPattern).map(s => s.trim());
    paragraphsArr.shift(); // Remove the part before (x1).

    const isTableEmbedded = /<table/i.test(fullText);
    const paragraphToUse = cleanTableBrTags(fullText);

    const answers = (item?.finalAnswer || item?.answer || "").split(XPattern).map(s => s.trim());

    return paragraphsArr.map((ele, index) => {
        const currentId = startCount + index + 1;
        const textContent = ele.replace(/<[^>]+>/g, '').trim();

        return {
            ...item,
            ...(index === 0 && {
                paragraph: paragraphToUse,
            }),
            isInsideTable: true, // Enable inline rendering via paragraph for all marker questions
            question_id: currentId.toString(),
            question: convertIntoMath(textContent),
            finalquestion: convertIntoMath(ele.trim()),
            qType: item.qtype,
            subID: Math.floor(Math.random() * 1000),
            answer: convertIntoMath(answers?.[index + 1]),
            finalAnswer: convertIntoMath(answers?.[index + 1]),
            html_tag: item.html_tag || item?.html_question,
            m_equation: item.m_equation,
            id: item.id,
            isOr: item?.isOr || false,
        };
    });
};

export const madeFinalObject = (payload, isFromEdit) => {
    let questionCount = 0;

    let finalPayload = payload?.map((item) => {
        return {
            ...item,
            divisions: item?.divisions?.map((data) => {
                let questionDataPayload = [];

                data?.question_data?.forEach((item) => {
                    item = {
                        ...item,
                        question: item?.question || item?.finalquestion,
                        answer: item?.finalAnswer || item?.answer,
                    };

                    const isParagraph = (item?.finalquestion || item?.question)?.includes('(x1).');
                    const isMatch = item?.perfact_metch?.length > 0 && !noColumnInQuestion.includes(item?.qtype);

                    if (isParagraph) {
                        const subQuestions = splitRectifyQuestion(item, questionCount, isFromEdit);
                        questionDataPayload.push(...subQuestions);
                        questionCount += subQuestions.length;
                    } else if (isMatch) {
                        item?.perfact_metch?.forEach((ele, ind) => {
                            questionCount++;
                            questionDataPayload.push({
                                ...item,
                                ...(ind === 0 && {
                                    paragraph: convertIntoMath(item?.finalquestion?.trim()),
                                }),
                                question_id: isFromEdit ? item?.question_id : questionCount,
                                questionLeft: convertIntoMath(ele?.finalquestion),
                                questionRight: convertIntoMath(ele?.finalanswer),
                                rightAnswer: convertIntoMath(ele?.finalrightAnswer),
                                id: item.id,
                                answer: convertIntoMath(item.answer),
                                qType: item.qtype,
                                que_id: item?.que_id,
                                html_tag: item.html_tag || item?.html_question,
                                m_equation: item.m_equation,
                            });
                        });
                    } else {
                        questionCount++;
                        questionDataPayload.push({
                            ...item,
                            question_id: isFromEdit ? item?.question_id : questionCount,
                            html_tag: item.html_tag || item?.html_question,
                            m_equation: item.m_equation,
                            question: convertIntoMath(formatOptionBreaks(item.question)),
                            finalquestion: convertIntoMath(formatOptionBreaks(item.finalquestion)),
                            id: item.id,
                            qType: item.qtype,
                            answer: convertIntoMath(item.finalAnswer),

                            ...(item?.option1 &&
                                item?.option2 &&
                                item?.option3 &&
                                item?.option4 && {
                                answers: [
                                    { answer: convertIntoMath(item?.option1) },
                                    { answer: convertIntoMath(item?.option2) },
                                    { answer: convertIntoMath(item?.option3) },
                                    { answer: convertIntoMath(item?.option4) },
                                ],
                            }),
                            ...(item?.finaloption1 &&
                                item?.finaloption2 &&
                                item?.finaloption3 &&
                                item?.finaloption4 && {
                                finalAnswers: [
                                    { answer: convertIntoMath(item?.finaloption1) },
                                    { answer: convertIntoMath(item?.finaloption2) },
                                    { answer: convertIntoMath(item?.finaloption3) },
                                    { answer: convertIntoMath(item?.finaloption4) },
                                ],
                            }),
                            ...(item?.option1_img &&
                                item?.option2_img &&
                                item?.option3_img &&
                                item?.option4_img && {
                                imgAnswers: [
                                    { answer: convertIntoMath(item?.option1_img) },
                                    { answer: convertIntoMath(item?.option2_img) },
                                    { answer: convertIntoMath(item?.option3_img) },
                                    { answer: convertIntoMath(item?.option4_img) },
                                ],
                            }),
                        });
                    }
                });

                return {
                    ...data,
                    question_data: questionDataPayload,
                };
            }),
        };
    });

    return finalPayload;
};